import React from "react";

import Heading from "components/heading";
import Image from "next/image";
import FigureImage from "public/images/enerflo-solar-financing.png";

import HeroSection from "../../hero-section";

const title = "Lendflo";

const Lendflo = () => (
  <HeroSection title={title} className="flex-col-reverse md:flex-row-reverse">
    <HeroSection.Content className="md:w-2/5">
      <HeroSection.Header className="md:items-start">
        <Heading tag="h2">{title}</Heading>
      </HeroSection.Header>
      <HeroSection.Description>
        Enerflo integrates with the Top 5 Solar Lenders and has the most lender integrations in the market, making
        lending easy and enabling reps to get their customers to NTP faster -- all through Lendflo.
      </HeroSection.Description>

      <HeroSection.Action className="btn-navy" href="/features/lendflo">
        Get Your Customers Financed Fast
      </HeroSection.Action>
    </HeroSection.Content>

    <figure className="p-3 w-full sm:w-3/5">
      <Image
        src={FigureImage}
        alt="Enerflo Solar Software Platform Lendflo Financing."
        layout="responsive"
        quality={100}
        placeholder="blur"
        className="crispImage"
        sizes="(min-width: 768px) 60vw, 100vw"
        lazyBoundary="400px"
      />
    </figure>
  </HeroSection>
);

export default Lendflo;
